import { Text } from "@artprov/design-system"
import PropTypes from "prop-types"

export default function HeadingGroup({ title, description, className = "" }) {
  const baseClasses = "flex flex-col"
  const combinedClasses = `${baseClasses} ${className}`

  return (
    <div className={combinedClasses}>
      {title && (
        <Text variant="h6" className="text-primary-20">
          {title}
        </Text>
      )}
      {description && (
        <Text variant="body2">
          {description}
        </Text>
      )}
    </div>
  )
}

HeadingGroup.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
}
